module.exports = __webpack_public_path__ + "img/TheVeryLastPizzaPreview.4575db2b.gif";